const images = document.querySelectorAll('img[data-src]')

const loadImage = () => {
    images.forEach(element => {
        if (element.getBoundingClientRect().top < window.innerHeight) {
            element.src = element.getAttribute('data-src')
        }
    })
    window.onscroll = function () {
        images.forEach(element => {
            if (element.getBoundingClientRect().top < window.innerHeight) {
                element.src = element.getAttribute('data-src')
            }
        })
    }
}

loadImage();




